import { useEffect, useMemo, useState } from 'react'
import { roundWithPrecision } from '@chilecompra/react-kit'

/**
 * The Score' custom hook.
 */
export const useScore = ({ rangeValues = [], rate = 0, max = 5 }) => {
  const [updatedRate, setUpdatedRate] = useState('0')

  const color = useMemo(() => {
    if (rangeValues.length === 0) {
      return 'primary'
    }

    let auxColor = 'primary'
    rangeValues.forEach(obj => {
      if (
        obj.min.type === 'exclusive' &&
        obj.max.type === 'exclusive' &&
        rate > obj.min.value &&
        rate < obj.max.value
      ) {
        auxColor = obj.color
      } else if (
        obj.min.type === 'exclusive' &&
        obj.max.type !== 'exclusive' &&
        rate > obj.min.value &&
        rate <= obj.max.value
      ) {
        auxColor = obj.color
      } else if (
        obj.min.type !== 'exclusive' &&
        obj.max.type === 'exclusive' &&
        rate >= obj.min.value &&
        rate < obj.max.value
      ) {
        auxColor = obj.color
      } else if (
        obj.min.type !== 'exclusive' &&
        obj.max.type !== 'exclusive' &&
        rate >= obj.min.value &&
        rate <= obj.max.value
      ) {
        auxColor = obj.color
      }
    })

    return auxColor
  }, [rate])

  useEffect(() => {
    setUpdatedRate(
      (roundWithPrecision(rate, 2) !== roundWithPrecision(max, 2)
        ? roundWithPrecision(rate, 2)
        : roundWithPrecision(rate, 0)
      )
        .toString()
        .replace('.', ',')
    )
  }, [rate])

  return { color, updatedRate }
}
